export default {
    isMobile: false,
}